function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import history from 'helpers/history';
import SessionStorage from 'libs/SessionStorage';
import BackToMainView from 'components/BackToMainView';
import urlRouteShape from 'shapes/urlRouteShape';
import App, { AlertsBus } from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import Create from '../../partials/Create';
import Join from '../../partials/Join';
var _React_PureComponent;
class ChooseOrganization extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        const { countryCode } = this.props.loadedIdentity;
        this.props.onFetchOrganizationTemplate(countryCode);
    }
    componentDidUpdate(prevProps) {
        const { isInProgress, hasErrors, openModalId } = this.props;
        if (prevProps.openModalId && !openModalId && this.isSucceed) {
            this.navigate();
        }
        if (prevProps.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.isSucceed = true;
        }
    }
    get countryCodes() {
        return [
            this.props.loadedIdentity.countryCode
        ];
    }
    get defaultCountryCode() {
        return this.props.loadedIdentity.countryCode;
    }
    navigate() {
        if (this.blsReturnUrl) {
            this.context.externalRedirect(this.blsReturnUrl);
            return;
        }
        const { name, params } = this.props.mainUrlRoute;
        const url = this.context.getUrl(name, params);
        history.replace(url);
    }
    renderBack() {
        if (!this.props.organizationMemberships.length) return null;
        return /*#__PURE__*/ _jsx(BackToMainView, {
            routeName: "organization-memberships",
            message: messages.headers.backToOrganizations
        });
    }
    renderHeader() {
        return /*#__PURE__*/ _jsx("header", {
            className: "pageHeader",
            children: /*#__PURE__*/ _jsx("h1", {
                className: "text--h2",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.chooseOrganization))
            })
        });
    }
    render() {
        const { countryCode } = this.props.loadedIdentity;
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderBack(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "pageContentBox",
                    children: [
                        this.renderHeader(),
                        /*#__PURE__*/ _jsx(AlertsBus, {
                            className: "mb-5"
                        }),
                        /*#__PURE__*/ _jsx(Join, {
                            countryCodes: this.countryCodes,
                            defaultCountryCode: this.defaultCountryCode
                        }),
                        /*#__PURE__*/ _jsx("hr", {
                            className: "form-divider"
                        }),
                        /*#__PURE__*/ _jsx(Create, {
                            countryCode: countryCode,
                            isSetup: this.props.isSetup
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.blsReturnUrl = SessionStorage.getItem('blsReturnUrl');
        this.isSucceed = false;
    }
}
_define_property(ChooseOrganization, "contextType", AppContext);
_define_property(ChooseOrganization, "propTypes", {
    // Explicit props
    isSetup: PropTypes.bool,
    // Implicit props
    loadedIdentity: Account.shapes.identity,
    organizationMemberships: PropTypes.array,
    mainUrlRoute: urlRouteShape,
    openModalId: PropTypes.string,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onFetchOrganizationTemplate: PropTypes.func
});
const mapStateToProps = (state)=>({
        isInProgress: selectors.isJoinOrganizationInProgress(state) || selectors.isCreateOrganizationInProgress(state),
        hasErrors: selectors.hasJoinOrganizationErrors(state) || selectors.hasCreateOrganizationErrors(state),
        loadedIdentity: Account.selectors.loadedIdentity(state),
        mainUrlRoute: Account.selectors.mainUrlRoute(state),
        organizationMemberships: Account.selectors.organizationMemberships(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onFetchOrganizationTemplate: ({ countryCode })=>dispatch(actions.fetchOrganizationTemplate(countryCode))
    });
const ConnectedChooseOrganization = connect(mapStateToProps, mapDispatchToProps)(ChooseOrganization);
export default ConnectedChooseOrganization;
